// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__qfksl","Arcade_form":"style_Arcade_form__TPMzy"};